import React from 'react';
import {MasterLayout} from 'layout';
import {ChiTietCuocThanhTra} from 'modules/thanh-tra';

export default class ChiTietCuocThanhTraKeHoachPage extends React.Component {
  
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <ChiTietCuocThanhTra params={this.props.params} type='KE_HOACH'/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/ChiTietCuocThanhTraKeHoachPage.jsx